// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1wWod","rootSuccess":"CompleteLink_rootSuccess__2GQOY","rootFailure":"CompleteLink_rootFailure__BvFBp","isDisabled":"CompleteLink_isDisabled__35evb"};